// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3pj59","errorLogs":"EditorFooter_errorLogs__1Q7mv"};